<template>
  <div class="Login">
    <div class="mainBox border absolute m-auto">
      <div class="imageBox relative">
        <img src="/assets/image/login.jpg" />
      </div>
      <div class="loginBox border align-center relative">
        <div v-if="!logined && !setPassword">
          <LoginForm 
            :title="siteTitle"
            @setPassword="handleSetPassword"
            @finished="processAfterLogin"
          />
        </div>
        <div v-else-if="!logined && setPassword">
          <PasswordForm 
            :account="account"
            @cancel="handleCancelPassword"
            @completed="handleCompletePassword"
          />
        </div>
        <div v-else>
          <LoginLoading
            @failed="handleFailedLoading"
            @finished="handleFinishedLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { site } from "@/common/mixins/site";
import LoginForm from "./components/LoginForm";
import LoginLoading from "./components/LoginLoading";
import PasswordForm from "./components/PasswordForm";

export default {
  name: "Login",
  mixins: [site],
  components: { LoginForm, LoginLoading, PasswordForm },
  data() {
    return {
      logined: false,
      setPassword: false,
      account: '',
    };
  },
  methods: {
    handleSetPassword(account) {
      this.account = account;
      this.setPassword = true;   
    },
    handleCancelPassword() {
      this.setPassword = false;
    },
    handleCompletePassword() {
      this.setPassword = false;
    },
    processAfterLogin() {
      this.logined = true;      
    },
    handleFailedLoading() {
      this.logined = false;
    },
    handleFinishedLoading() {
      let redirect = this.$route.query.redirect || "/";
      this.$router.push({ path: redirect });
    }
  }
};
</script>

<style lang="scss" scoped>
.mainBox {
  width: 800px;
  height: 365px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.imageBox {
  float: left;
  left: 40px;
  top: 40px;
  img {
    max-height: 280px;
    border: 1px solid #000;
  }
}
.loginBox {
  width: 240px;
  height: 280px;
  float: right;
  border-radius: 4px;
  right: 40px;
  top: 40px;
}
</style>